import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Textfit } from 'react-textfit';

import EmojiParsed from '../../../../../components/global/AutoP/EmojiParsed';
import useComponentSize from '../../../../../hooks/useComponentSize';

const propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  fitText: PropTypes.bool,
};

const CardElementTextFormat = ({ className, text = '', fitText }) => {
  const classes = classNames({
    'card-element-text-format': true,
    [className]: !!className,
  });
  const ref = useRef();
  const { width, height } = useComponentSize(ref);

  return fitText ? (
    <span
      ref={ref}
      style={{
        display: 'block',
        width: '100%',
        height: '100%',
      }}
      className={classes}
    >
      <Textfit
        key={width * height}
        mode="multi"
        className="text-fit"
        max={9999}
      >
        <EmojiParsed text={text} />
      </Textfit>
    </span>
  ) : (
    <pre className={classes}>
      <EmojiParsed text={text} />
    </pre>
  );
};

CardElementTextFormat.propTypes = propTypes;

export default CardElementTextFormat;
